import { seoConfig } from "../seo/siteConfig";

export interface FarmInfo {
  name: string;
  tagline: string;
  description: string;
  history: string;
  values: string[];
  stats: {
    acres: number;
    varieties: number;
    years: number;
    customers: number;
  };
  location: string;
  contact: {
    phone: string;
    phone2?: string;
    email: string;
    address: string;
  };
  socialMedia: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
  };
}

export const farmInfo: FarmInfo = {
  name: "Golden Harvest Mango Farm",
  tagline: "Growing Nature's Sweetest Treasures",
  description:
    "We are a family-owned mango farm dedicated to cultivating the finest varieties of mangoes using sustainable farming practices. Our commitment to quality and tradition has made us a trusted name in premium mango production.",
  history:
    "Founded in 1988 by the Patel family, Golden Harvest Mango Farm began with a dream to grow the world's best mangoes. Over three generations, we've expanded to 150 acres while maintaining our commitment to traditional farming methods combined with modern sustainable practices. Our farm has become a model for organic mango cultivation in the region.",
  values: [
    "Sustainable farming practices",
    "Premium quality assurance",
    "Family tradition and heritage",
    "Environmental stewardship",
    "Community support and growth",
    "Innovation in agriculture",
  ],
  stats: {
    acres: 150,
    varieties: 12,
    years: 37,
    customers: 5000,
  },
  location: "Raghunathpur, Saharanpur, Uttar Pradesh, India",
  contact: {
    phone: seoConfig.business.phone,
    phone2: seoConfig.business.phone2,
    email: seoConfig.business.email,
    address:
      "Golden Harvest Mango Farm, Raghunathpur, Saharanpur, Uttar Pradesh 247231, India",
  },
  socialMedia: {
    // facebook: "https://facebook.com/goldenharvestmango",
    // instagram: "https://instagram.com/goldenharvestmango",
    // twitter: "https://twitter.com/goldenharvestmango",
  },
};
